import React, { useState, useEffect } from 'react';

const SDMa05_TableRow = ({ dev_id, s, update_mobile_actual_dev_sensor_fields }) => {
  
  
  const [activeFields, setActiveFields] = useState(() =>
    s.last_value.map((v) => v.db_field) // initial active
  );
  useEffect(() =>{
    update_mobile_actual_dev_sensor_fields('clecked_actual_fields', 
    {dev_id: dev_id,
     sensor_id: s.sensor_id,
     actual_fields: activeFields
   })
  }, [activeFields])
  //update_request_graph_by_sensor('tmp_field_list', activeFields)
  //console.log('activeFields row element:', activeFields)
/*   update_mobile_actual_dev_sensor_fields('clecked_actual_fields', 
  {dev_id: dev_id,
   sensor_id: s.sensor_id,
   actual_fields: activeFields
 }) */

  const handleClick = (field) => {
    
    setActiveFields((prevFields) => {
      const isActive = prevFields.includes(field);
      const updatedFields = isActive
        ? prevFields.filter((f) => f !== field)
        : [...prevFields, field];

        //console.log('activeFields row element2:', updatedFields)
        //updatePageActualFields(updatedFields); // update parent
/*         update_mobile_actual_dev_sensor_fields('clecked_actual_fields', 
        {dev_id: dev_id,
         sensor_id: s.sensor_id,
         actual_fields: updatedFields
       }) */
      return updatedFields;
    });
  };

  if (s.sens_is_error_status) {

    return (
      <tr>
        <td colSpan="2">
          <span className="psdm__name--gray">Sensor Error. No actual data...</span>
        </td>
      </tr>
    );
  }

  return (
    <>
      {s.last_value.map((v, i) => {
        const valueName = v.card_mobile_name || v.card_prefix;
        const isActive = activeFields.includes(v.db_field);
        return (
          <tr key={v.db_field || i}>
            <td onClick={() => handleClick(v.db_field)}>
              <span className={isActive ? '' : 'psdm__name--gray'}>
                {valueName}
              </span>
            </td>
            <td>{`${v.s_value}${v.card_suffix}`}</td>
          </tr>
        );
      })}
    </>
  );
};

export default SDMa05_TableRow;
